import type { SVGProps } from 'react';

export function FarmAnimalIcon({
  size = 24,
  strokeWidth = 1.5,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number | string; strokeWidth?: number | string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M5.25 2.25C5.25 3.44347 5.72411 4.58807 6.56802 5.43198C7.41193 6.27589 8.55653 6.75 9.75 6.75H14.25C15.4435 6.75 16.5881 6.27589 17.432 5.43198C18.2759 4.58807 18.75 3.44347 18.75 2.25M16.5 15H7.5C5.84315 15 4.5 16.3431 4.5 18C4.5 19.6569 5.84315 21 7.5 21H16.5C18.1569 21 19.5 19.6569 19.5 18C19.5 16.3431 18.1569 15 16.5 15ZM7.5 18H9M15 18H16.5M15 6.75H18.0731C19.1127 6.74971 20.1203 7.10936 20.9248 7.76785C21.7292 8.42634 22.2808 9.34304 22.4859 10.3622C22.5062 10.4704 22.5023 10.5817 22.4747 10.6882C22.4471 10.7948 22.3964 10.8939 22.3261 10.9786C22.2559 11.0634 22.1679 11.1316 22.0683 11.1785C21.9687 11.2254 21.8601 11.2498 21.75 11.25H18M8.99871 6.75H5.92558C4.886 6.74971 3.87839 7.10936 3.07395 7.76785C2.26951 8.42634 1.71787 9.34304 1.51277 10.3622C1.49255 10.4704 1.49638 10.5817 1.524 10.6882C1.55162 10.7948 1.60235 10.8939 1.67259 10.9786C1.74282 11.0634 1.83085 11.1316 1.93042 11.1785C2.02998 11.2254 2.13865 11.2498 2.24871 11.25H5.99871M6 15.4012V9.75C6 8.95435 6.31607 8.19129 6.87868 7.62868C7.44129 7.06607 8.20435 6.75 9 6.75H15C15.7956 6.75 16.5587 7.06607 17.1213 7.62868C17.6839 8.19129 18 8.95435 18 9.75V15.4012"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="9.375" cy="11.625" r="1.125" fill="currentColor" />
      <circle cx="14.625" cy="11.625" r="1.125" fill="currentColor" />
    </svg>
  );
}
